<script>	// custom svelte components
	import Dropdown  from '../components/helpers/Dropdown.svelte';
    import Scrolly from './helpers/Scrolly.svelte';
    import { scale, fade } from 'svelte/transition';
    import State from '../stores/State.js';
    import { max } from 'd3';
	import { onMount } from 'svelte';
    import { shareOnTwitter, shareOnFacebook, shareOnLinkedIn, shareOnClipboard } from '../actions/sharing.js';

    import FinishChart from './FinishChart.svelte';
    import LineChart from './LineChart.svelte';
    import FinishSim from './FinishSim.svelte';
    import PlaceChart from './PlaceChart.svelte';
    import ChartNav from './ChartNav.svelte';

    import textBlocks from '../data/textBlocks.js';
    import lapData from '../data/raceLapData.js';
    import races from '../data/racesData.js';


	let scrollValue;
    let w;
    let playing = false;
    let playingPoints = false;
    let replaying = false;
    let timeouts = [];
    let sounds = [];
    let interval;
    let pc;
    let showOptions = false;
    let winW = 960;
    // Finish Simulation Timer/Clock
    let time = 0;
    let toast = false;
    

    $: getChart(scrollValue);

	$: driverLaps = $State.intro ? lapData[$State.intro] : lapData[$State.selRace.race];

    $: driverLastLaps = getLastLaps(driverLaps);

    $: maxLastVP1 = max(driverLastLaps.map((d) => d.pos <= 10 && d.lap == $State.selRace.lapCount ? d.vsP1 : 0 ));

    $: $State.selRace, stopSim();


    // delay timer start so you can hear car runnup
    $: timer = time > 2.1 ? time -2.1 : 0;

    // honestly don't fully understand the calc I did here, it seems convoluted.
    // but I made it and it works
    $: scaleFactor = winW < 960 ? 1-((1-winW/960)/4) : 1;

    
    function getChart(scrollVal){
        if (typeof(scrollVal) != "undefined") {
            if (playingPoints && typeof pc !== undefined && $State.selChart === 'Place') pc.stopReplay;
            $State.prevChart = $State.selChart;
            if (typeof textBlocks[scrollVal].selChart !== 'undefined') {
                $State.selChart = textBlocks[scrollVal].selChart;
            }
            $State.selRace = races.filter( r => r.race === textBlocks[scrollVal].selRace)[0];
            $State.selDriver = textBlocks[scrollVal].selDriver;
            $State.intro = typeof(textBlocks[scrollVal].intro) != "undefined" ? textBlocks[scrollVal].intro : "";
            $State.showNav = typeof(textBlocks[scrollVal].showNav) != "undefined" ? textBlocks[scrollVal].showNav : $State.showNav;
            $State.scrollValue = scrollVal;
        }
    }

    function getLastLaps (driverLaps) {
        let lastLaps = []
        driverLaps.forEach(el => {
            let x = {};
            x = el.laps[el.laps.length-1];
            x.driver = el.driver;
            if (x.lap + 2 >= $State.selRace.lapCount && x.pos <= 10) lastLaps.push(x);
        });
        return lastLaps;
    }


    let racebySound = [];
    // Fix up prefixing
    window.AudioContext = window.AudioContext || window.webkitAudioContext;
    let context = new AudioContext();


    function loadSound(url) {
        let request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.responseType = 'arraybuffer';
        // Decode asynchronously
        request.onload = function() {
            context.decodeAudioData(request.response, function(buffer) {
                if (!buffer) {
                    console.log('Error decoding file data: ' + url);
                    return;
                }
            racebySound.push(buffer);
            });
        };
        request.onerror = function() {
            console.log('BufferLoader: XHR error');        
            };
        request.send();
    }

    function playSound(buffer, time, volume) {            
        var source = context.createBufferSource();   // creates a sound source
        source.buffer = buffer;                     // tell the source which sound to play
        source.connect(context.destination);          // connect the source to the context's destination (the speakers)
        var gainNode = context.createGain();          // Create a gain node
        source.connect(gainNode);                     // Connect the source to the gain node
        gainNode.connect(context.destination);        // Connect the gain node to the destination
        gainNode.gain.value = volume;                  // Set the volume
        source.start(time);                           // play the source at the deisred time 0=now  
        sounds.push(source); 
    }



    function playSim (length) {
        playing = true;
        time = 0;
        timeouts.push(setTimeout(stopSim, length + 5000));
        interval = setInterval(() => {time =time + 0.1}, 100);
        driverLastLaps.forEach(lp => {
            if (lp.lap == $State.selRace.lapCount && lp.pos <= 10) {          
                timeouts.push(setTimeout(() => {playSound(racebySound[lp.pos % 3], 0, 1)}, lp.vsP1));
            }
        });

    }  
    
    function stopSim () {
            playing = false;
            timeouts.forEach((v) => { 
                clearTimeout(v);
            }) 
            timeouts = [];
            clearInterval(interval);
            sounds.forEach((v) => {
                //v.pause();
                v.stop(0)
            })
            sounds = [];
    }

    function togglePCplay () {
        if (playingPoints) {
            playingPoints = false;
            pc.stopReplay();
        }
        else {
            playingPoints = true;
            pc.replay();
        }
    }

    function popToast(){
        toast = true;
        setTimeout(()=> toast = false, 1000);
    }

    function skipStory() {
        $State.showNav = true;
        document.getElementById('end').scrollIntoView();
    }

    function returnStory() {
        document.getElementById('titleScreen').scrollIntoView();
    }

	onMount(() => {

        $State.noFade = false;
        
        loadSound('/audio/raceby-1.mp3');
        loadSound('/audio/raceby-2.mp3');
        loadSound('/audio/raceby-3.mp3');
        if ($State.showNav) {
            setTimeout(() => document.getElementById('end').scrollIntoView(),1);
        } else if (typeof $State.scrollValue !== 'undefined') {
            setTimeout(() => document.getElementById('step-' + $State.scrollValue).scrollIntoView({ block: 'center' }),0);
        }

	});
   
	
</script>


<svelte:window bind:innerWidth={winW}/>
  

<div class="container">
    <section id="LRscrolly">
        <div class="stick" style="transform: scale({scaleFactor}); transform-origin: top center;">

            {#if playing}
                {#each driverLastLaps as dr (dr.driver)}
                    {#if dr.pos <= 10 && dr.lap == $State.selRace.lapCount}
                        <FinishSim  {dr} />
                    {/if}
                {/each}
                <div class="timer">{(Math.round(timer*10)/10).toFixed(1)}</div>
            {/if}

            {#if $State.selChart === "Places"}
            <h2 in:scale={{ duration:500}}>
                Championship
            </h2>
            {:else}

                {#key $State.selRace.race}
                    <h2 bind:clientWidth={w} 
                        in:scale={{ duration:500}}
                        class={$State.selRace.font} 
                        style=" 
                            {playing ? "filter: blur(2px);-webkit-filter: blur(2px); opacity: 0.7" : ""}
                            "
                        >
                        {$State.selRace.race} 
                        <img class="track" src="/images/tracks/{$State.selRace.track}.svg" alt="{$State.selRace.track} track outline"/>
                    </h2>
                {/key}
                
                <Dropdown options={races}
                    bind:value={$State.selRace}
                    index={races.findIndex(d => d.race === $State.selRace.race)}
                    btn_offset={w}
                    {playing} 
                    bind:showOptions={showOptions}
                />
            {/if}
           

            
            {#if $State.selChart === "Lightning"}
                <h3>Watch the drivers bolt for the finish in <strong>Lightning Plots</strong></h3>
                <button class="simBtn" on:click="{() => replaying = !replaying}"></button>
                <div class="btnText">Replay</div>
                <a href="/lgrid" on:click={() => {$State.noFade = true;}}><button class="simBtn gridBtn"></button></a>
                <div class="btnText">Grid</div>
            {:else if $State.selChart === "Finish"}
                {#if !playing}
                    <h3><strong>Finish Traces</strong> expose how far behind the winner drivers finished.</h3>
                {:else}
                    <div class="road">&nbsp;</div>
                {/if}
                <button class="simBtn {playing ? 'simBtnStop' : ''}" on:click="{() => playing ? stopSim() : playSim(maxLastVP1)}"></button>
                <div class="btnText">{playing ? 'Stop Simulation' : 'Simulate Finish'}</div>   
                <!-- <a href="/fgrid" on:click={() => {$State.noFade = true;}}><button class="simBtn gridBtn"></button></a> -->
                <!-- <div class="btnText">Grid</div>   -->
            {:else if $State.selChart === "Places"}
                <h3>Drivers race for the 2021 World Championship</h3>
                <button class="simBtn {playingPoints ? 'simBtnStop' : ''}" on:click="{togglePCplay}"></button>
                <div class="btnText">{playingPoints ? 'Stop' : 'Replay'}</div>   
            {/if}


            {#if $State.selChart === "Lightning"}
                <LineChart {driverLaps} {replaying} {scaleFactor}/>
            {:else if $State.selChart === "Finish"}
                <FinishChart {driverLastLaps} {playing}/>
            {:else if $State.selChart === "Places"}
                <PlaceChart bind:this={pc} bind:placePlaying={playingPoints} />
            {/if}
            
            
            {#if $State.showNav}
                <ChartNav />
            {/if}

           

        <div class="pageNav" style="top: calc({100 / scaleFactor}vh - 70px);">
            <a href= "/" style="float:right; line-height: 22px;" on:click={() => returnStory()}>Back to Top</a>
            <a href="/about" on:click={() => {$State.noFade = true; playingPoints ? pc.stopReplay : ''}}>About Me</a>
            &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="/credits" on:click={() => {$State.noFade = true; playingPoints ? pc.stopReplay : ''}}>Credits</a>
            &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;
            <img role="button" class="shareIcon" on:click="{() => shareOnTwitter()}" src="/images/share-twitter.svg" alt="share on twitter"/>
            <img role="button" class="shareIcon" on:click="{() => shareOnLinkedIn()}" src="/images/share-linkedin.svg" alt="share on LinkedIn"/>
            <img role="button" class="shareIcon" on:click="{() => shareOnFacebook()}" src="/images/share-facebook.svg" alt="share on facebook"/>
            <img role="button" class="shareIcon" on:click="{() => {shareOnClipboard(); popToast();}}" src="/images/share-clipboard.svg" alt="copy link to clipboard"/>
            {#if toast}
                <div class="toast" transition:fade >Link copied to clipboard</div>
            {/if}
        </div>

            
        </div>


        
		<Scrolly bind:value={scrollValue}>
			{#each textBlocks as tb, i}
                <div class="step" id="step-{i}" class:active={scrollValue === i} class:hideStep={showOptions}>
                    <p>{@html tb.text}
                        {#if tb.button === 'simFinish'}
                            <br>
                            <span style="margin-top: 20px; line-height:40px;">
                                <button class="simBtn {playing ? 'simBtnStop' : ''}" style="height:24px; width:24px; margin:0" on:click="{() => playing ? stopSim() : playSim(maxLastVP1)}"></button>
                                <div class="btnText" style="line-height:24px; margin-top:0px; vertical-align:middle">{playing ? 'Stop Simulation' : 'Simulate Finish'}</div>   
                            </span>
                        {:else if tb.button === 'skipStory'}
                                <div role="button" class="skipBtn" on:click="{() => skipStory()}" style="text-align:right; cursor:pointer; ">Skip Story</div>   
                        {/if}
                    </p>    
                </div>
			{/each}
		</Scrolly>
		<div id="end" class="spacer" />
	</section>	
    
</div>




<style>

    .skipBtn {
        color: #9CBCE0;
        text-transform: uppercase;
        font-size: 12px;
        font-family: 'Poppins', 'Century Gothic', sans-serif;
    }

    .toast {
        display: inline-block;
        line-height: 9px;
        transform: translate(-150px, -32px);
        background: #222;
        padding: 4px 8px;
        border-radius: 5px;
        box-shadow: -1px -1px 3px rgb(155 155 155 / 25%), 3px 3px 5px #000000;
    }



    .timer {
        position: absolute;
        left: 670px;
        width: 136px;
        text-align: right;
        font-size: 3.5em;
        opacity: 0.75;
        box-shadow: inset 1px 2px 4px rgb(0 0 0 / 80%), inset -1px -1px 4px rgb(255 255 255 / 50%);
        /* font-style: italic; */
        /* font-weight: 100; */
        padding: 0 20px 0 15px;
        border-radius: 8px;
        line-height: 1.15em;
        vertical-align: bottom;
        margin: 12px 0;
        
    }

    .btnText {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        vertical-align: bottom;
        margin-left: 10px;
        color: #F0B8C9;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        font-family: Poppins;
        font-weight: 800;
    }

    .simBtn {
        margin-top: 15px;
        margin-bottom: 0;
        width: 30px;
        height: 30px;
        border-radius: 99px;
        border: 1px solid #343135;
        background-color: #00000000;
        box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000;
        background-image: url("data:image/svg+xml;utf8,<svg width='8' height='10' viewBox='0 0 10 13' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M11 6L2 11L2 1L11 6Z' fill='white'/></svg>");
        background-repeat: no-repeat;
        background-position: center;
        -webkit-appearance: none;
    }
    
    .simBtnStop {
        background-image: url("data:image/svg+xml;utf8,<svg width='8' height='10' viewBox='0 0 10 13' fill='none' xmlns='http://www.w3.org/2000/svg'><rect x='1' y='2  ' width='8' height='8' fill='white'/></svg>");
    }

    .simBtn:hover {
        box-shadow: -2px -2px 8px 0px #FFFFFF80, 2px 3px 8px 1px #000000, 0 0 0 2px #FF285D;
    }

    .simBtn:active {
        box-shadow: inset 1px 2px 2px rgba(0, 0, 0, 0.8), inset -1px -1px 2px rgba(255, 255, 255, 0.5);
        background-color: #00000000;
    }

    .gridBtn {
        margin-left: 40px;
        background-image: url("data:image/svg+xml;utf8,<svg width='12' height='12' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg'><rect x='0' y='0' width='5' height='5' fill='white'/><rect x='7' y='0' width='5' height='5' fill='white'/><rect x='0' y='7' width='5' height='5' fill='white'/><rect x='7' y='7' width='5' height='5' fill='white'/></svg>")
        
    }


    .road {
        height: 36px;
        margin-left: calc(50% - 55vw);
        width: 110vw;
        background: linear-gradient(180deg, rgba(68, 68, 68, 0) 0%, #444444 35%, #444444 60%, rgba(68, 68, 68, 0) 100%);
        overflow: hidden;
    }

    @media screen and (max-height: 770px) {
        .road {
            height: 25px;
        }
        .timer {
            font-size: 2.5em;
        }
    }

    .track {
        height: 60px;
        min-width: 80px;
		filter: url(#trackBlur);
		-webkit-filter: url(#trackBlur);
        overflow: visible;
    }

    @media screen and (max-width: 650px), 
           screen and (max-height: 770px) {
        .track {
            height: 45px;
            min-width: 60px;
        }
    }
    
    .stick {
        position: sticky;
        top: 2em;
    }
    
  
	section {
	  margin: 2em auto;
	  padding-top: 4em;
	}
  
	h2 {
	  font-weight: bold;
      transition: width 2s;
	}
  
	/* span {
	  background: green;
	  padding: 0 0.5em;
	} */
  
	.spacer {
	  height: 25vh;
	}
  

    .container {
	  max-width: 1200px;
	  margin: 0 auto;
    }

	.step {
	  min-height: 25vh;
      margin-top: 80vh;
      margin-bottom: 80vh;
      margin-left: 900px;
      opacity: 0.5;
      pointer-events: none;
      /* padding-left: 700px; */
	}

    .step:last-child {
        min-height: 80vh;
    }

    .step p {
        pointer-events: all;
            padding: 20px;
            background-color: #222;
            border-radius: 6px;
            box-shadow: -2px -2px 6px rgba(155, 155, 155, 0.25), 10px 10px 15px #000000;
    }
 
    @media screen and (max-width: 1280px) {
        .container {
	        max-width: 900px;
        }
        .step {
            margin-left: auto;
            margin-right: auto;
            max-width: 340px;
            
        }

        .step p {
            padding: 20px;
            background-color: #222;
            border-radius: 6px;
            box-shadow: -2px -2px 6px rgba(155, 155, 155, 0.25), 10px 10px 15px #000000;
        }
    }

    @media screen and (max-width: 520px) {
        .step p {
            font-size: 18px;
        }
    }


    .active {
        /* opacity < 1 brings the element to the top of the dom */
        opacity: 0.9999;
    }
    .hideStep {
        opacity :1
    }

    /* .blur {
        position: absolute;
        z-index: 9;
        transform: translate(-20px -10px);
    } */
    .pageNav {
        position: fixed;
        top: calc(100vh - 70px);
        font-size: 12px;
        font-family: 'Poppins', 'Century Gothic', sans-serif;
        max-width: 840px;
        width: 100%;
        /* padding-bottom: 40px; */
        /* margin: 20px 0 1em 0; */
        /* background-color: black; */
        /* text-align: right; */
    }

    .pageNav a {
        color: #9CBCE0;
        text-transform: uppercase;
    }


    .pageNav a:hover {
        text-decoration: none;
        border-bottom: 1px dashed #9CBCE0;
    }

    .shareIcon {
        height: 20px;
        vertical-align: bottom;
        margin-left: 10px;
        cursor: pointer;
    }

</style>